import { defineComponent as _defineComponent } from 'vue'
import {
	watch,
	withDefaults,
	ref,
	Ref,
	nextTick,
} from "vue"

// content
interface Props {
	selected: number
	open: boolean
	totalAvailable: number
	speed: number
	maximum: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'hebergementDropdownV2',
  props: {
    selected: { default: 1 },
    open: { type: Boolean, default: false },
    totalAvailable: { default: 1 },
    speed: { default: 100 },
    maximum: { default: 20 }
  },
  emits: ["select"],
  setup(__props: any, { emit }: { emit: ({
	(e: "select", value: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { selected: number, open: boolean, totalAvailable: number, speed: number, maximum: number }

const content = window.content

// Props


// Template refs
const dropdown: Ref<HTMLDivElement | null> = ref(null)

// Emits


const handleClick = (newSelected: number): void => {
	emit("select", newSelected)
}

const fadeIn = (display: string = "block"): void => {
	if (!dropdown.value) return

	const value = dropdown.value
	value.style.display = display

	nextTick(() => {
		value.style.opacity = "1"
	})
}
const fadeOut = (): void => {
	if (!dropdown.value) return
	const value = dropdown.value

	value.style.opacity = "0"
	setTimeout(() => {
		value.style.display = "none"
	}, props.speed)
}

const checkIsSelected = (index: number): boolean => {
	return index === props.selected
}

// Watchers
watch(
	() => props.open,
	(newVal, oldVal) => {
		if (newVal && !oldVal) {
			fadeIn()
		} else if (!newVal && oldVal) {
			fadeOut()
		}
	}
)

return { __sfc: true,content, props, dropdown, emit, handleClick, fadeIn, fadeOut, checkIsSelected }
}

})